import { EnvironmentProviders, inject, InjectionToken, makeEnvironmentProviders } from "@angular/core";
import { SchabuSdk } from "@schabu/web.sdk";
import { ENVIRONMENT } from "environments/environment";

export const SCHABU_SDK_TOKEN: InjectionToken<string> = new InjectionToken<string>("SCHABU_SDK_TOKEN");

export function provideSchabuSdk(): EnvironmentProviders {
	return makeEnvironmentProviders([
		{
			provide: SchabuSdk,
			useFactory: () => {
				return new SchabuSdk(ENVIRONMENT.schabu);
			}
		}
	]);
}